import types from './types'
import cookie from 'js-cookie'

export default {
  [types.mutations.set]: (state, user) => {
    if (user) {
      state.user = user
      cookie.set('user', user)
    } else {
      state.user = null
      cookie.remove('user')
    }
  },
  [types.mutations.setLocale]: (state, locale) => {
    state.locale = locale
    localStorage.setItem('locale', locale)
  }
}
